import api from './api';
import type { VoucherDto, CreateVoucherDto, UpdateVoucherDto } from '../types/vouchers.types';

const VOUCHER_TYPE = 'CHP';

export const checkPaymentsService = {
  // Get all check payment vouchers - CHP ONLY
  getAll: async (): Promise<VoucherDto[]> => {
    try {
      const response = await api.get(`/Vouchers`, {
        params: { voucherType: VOUCHER_TYPE }
      });
      
      
      // Handle different response formats
      let data = response.data;
      
      // Extract array from various response formats
      if (Array.isArray(data)) {
        // Already an array
      } else if (data && Array.isArray(data.data)) {
        data = data.data;
      } else if (data && data.$values && Array.isArray(data.$values)) {
        data = data.$values;
      } else {
        console.warn('⚠️ Unexpected response format:', data);
        return [];
      }
      
      // CRITICAL: Filter to ensure ONLY CHP vouchers
      const chpVouchers = data.filter((v: any) => v.voucherType === 'CHP');
      
      
      return chpVouchers;
    } catch (error) {
      console.error('❌ Error fetching CHP vouchers:', error);
      return [];
    }
  },

  // Get by ID
  getById: async (id: number): Promise<VoucherDto> => {
    const response = await api.get(`/Vouchers/${id}`);
    return response.data;
  },

  // Create
  create: async (dto: CreateVoucherDto): Promise<VoucherDto> => {
    const response = await api.post('/Vouchers', dto);
    return response.data;
  },

  // Update
  update: async (id: number, dto: UpdateVoucherDto): Promise<VoucherDto> => {
    const response = await api.put(`/Vouchers/${id}`, dto);
    return response.data;
  },

  // Delete
  delete: async (id: number): Promise<void> => {
    await api.delete(`/Vouchers/${id}`);
  },

  // Post
  post: async (id: number): Promise<void> => {
    await api.post(`/Vouchers/${id}/post`);
  },

  // Unpost
  unpost: async (id: number): Promise<void> => {
    await api.post(`/Vouchers/${id}/unpost`);
  },
};

export default checkPaymentsService;